/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationSitemapEntry
 */
export interface LocationSitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof LocationSitemapEntry
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof LocationSitemapEntry
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof LocationSitemapEntry
     */
    humanId: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationSitemapEntry
     */
    isTopCity: boolean;
}

/**
 * Check if a given object implements the LocationSitemapEntry interface.
 */
export function instanceOfLocationSitemapEntry(value: object): value is LocationSitemapEntry {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('humanId' in value) || value['humanId'] === undefined) return false;
    if (!('isTopCity' in value) || value['isTopCity'] === undefined) return false;
    return true;
}

export function LocationSitemapEntryFromJSON(json: any): LocationSitemapEntry {
    return LocationSitemapEntryFromJSONTyped(json, false);
}

export function LocationSitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationSitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'url': json['url'],
        'humanId': json['humanId'],
        'isTopCity': json['isTopCity'],
    };
}

export function LocationSitemapEntryToJSON(value?: LocationSitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'url': value['url'],
        'humanId': value['humanId'],
        'isTopCity': value['isTopCity'],
    };
}

